const W = 640;
const H = 210;
const PAD = { top: 18, right: 18, bottom: 28, left: 36 };
const INTERVALS = 4;

function niceStep(span) {
  const raw = span / INTERVALS;
  const mag = 10 ** Math.floor(Math.log10(raw));
  for (const m of [1, 2, 2.5, 5, 10]) {
    if (mag * m >= raw - 1e-9) return mag * m;
  }
  return 10 * mag;
}

function fmt(d) {
  if (!d) return "";
  const dt = new Date(`${d}T00:00:00`);
  return Number.isNaN(dt.getTime()) ? d : dt.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export function TrendChart({ labels = [], values = [] }) {
  const dataMax = Math.max(...values, 0);
  const minTop = 6;
  const step = niceStep(Math.max(dataMax, minTop));
  const max = Math.max(minTop, Math.ceil(dataMax / step) * step);
  const plotW = W - PAD.left - PAD.right;
  const plotH = H - PAD.top - PAD.bottom;
  const stepX = labels.length > 1 ? plotW / (labels.length - 1) : plotW;
  const points = values.map((v, i) => [PAD.left + i * stepX, PAD.top + plotH - (v / max) * plotH]);
  const baselineY = (PAD.top + plotH).toFixed(1);
  const line = points.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const area = line ? `${line} L${points[points.length - 1][0].toFixed(1)},${baselineY} L${PAD.left},${baselineY} Z` : "";
  const ticks = Array.from({ length: INTERVALS + 1 }, (_, i) => Math.round((max * i) / INTERVALS));

  return (
    <div className="trend-chart">
      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" role="img" aria-label="Booking trend">
        {ticks.map((t) => {
          const y = PAD.top + plotH - (t / max) * plotH;
          return (
            <g key={t}>
              <line className="trend-gridline" x1={PAD.left} x2={W - PAD.right} y1={y} y2={y} />
              <text className="trend-axis" x={PAD.left - 6} y={y + 3} textAnchor="end">{t}</text>
            </g>
          );
        })}
        {line && <path className="trend-area" d={area} />}
        {line && <path className="trend-line" d={line} />}
        {points.map(([x, y], i) => (
          <g key={labels[i] || i}>
            <circle className="trend-dot" cx={x} cy={y} r={3} />
            {i % Math.max(1, Math.ceil(labels.length / 6)) === 0 && (
              <text className="trend-axis" x={x} y={H - 8} textAnchor="middle">{fmt(labels[i])}</text>
            )}
          </g>
        ))}
      </svg>
    </div>
  );
}